export const PickingResource = {
  name: "Picking",
  path: "/pickpack/picking",
  access: ["read-pickings"],
};
